module.exports = __webpack_public_path__ + "static/media/ahlenculs.52f2477.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ahlenculs.mp3
// module id = 19
// module chunks = 0